import React, {Component} from 'react'
import axios from './axios-data'
import CreateAccount from '../src/pages/createAccount/createAccount'
import validateCreateAccountCheck from './pages/createAccount/validation/validateCreateAccountCheck'
import Verification from '../src/pages/verification/verification'
import validateVerification from '../src/pages/verification/validation/validateVerification'
import Email from '../src/pages/email/email'
import LiveCheck from '../src/pages/liveCheck/liveCheck'
import Confirmation from '../src/pages/confirmation/confirmation'
import Consents from '../src/pages/consents/consents'
import * as jsonHeaders from '../src/services/serviceHeaders'
import * as consumerConsentsService from '../src/services/consumerConsentsService'
import Header from './components/DesignSystem/Header'
import {analytics} from './services'
import {Text, Box, Center} from '@chakra-ui/react'
import Footer from './components/layout/Footer'

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            //CurrentStep can be adjusted for testing (1,2,3,4)
            currentStep: 1,
            //Create Account
            accountExist: false,
            branch: null,
            dateOfBirth: '',
            isRegistered: null,
            lastName: '',
            ssn: '',
            //Verification
            apt: '',
            city: '',
            firstName: '',
            mobile: '',
            mobileType: '',
            stateCode: '',
            streetAddress: '',
            suffix: '',
            zipCode: '',
            //Email
            email: '',
            password: '',
            //Consents
            edeliveryDisclosure: false,
            esignDisclosure: false,
            liveCheckCustomer: false,
            TCPADisclosure: false,
            //Utility
            emailErrorMessage: null,
            emailIsUnique: null,
            emailVerified: false,
            failedVerification: false,
            nextDisabled: false,
            token: '',
            verificationAttempts: 0,
            //resend code
            accountNumber: '',
            branchId: '',
            namesId: '',
            //Confirmation
            enrollingError: false,
        }

        this.verifyCallback = this.verifyCallback.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleContinue = this.handleContinue.bind(this)
        this.register = this.register.bind(this)
        this.emailCheck = this.emailCheck.bind(this)
        this.saveConsents = this.saveConsents.bind(this)
    }

    handleESignChange = () => {
        this.setState({esignDisclosure: !this.state.esignDisclosure})
    }
    handleEDeliveryChange = () => {
        this.setState({edeliveryDisclosure: !this.state.edeliveryDisclosure})
    }
    handleTCPAChange = () => {
        this.setState({TCPADisclosure: !this.state.TCPADisclosure})
    }

    register = () => {
        let form = JSON.stringify({
            email: this.state.email,
            password: this.state.password,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            accessCode: this.state.branchId + '-' + this.state.accountNumber,
            ssn: this.state.ssn,
            dateOfBirth: this.state.dateOfBirth,
            mobile: this.state.mobile,
            esignDisclosure: this.state.esignDisclosure,
            edeliveryDisclosure: this.state.edeliveryDisclosure,
            TCPADisclosure: this.state.TCPADisclosure,
        })
        const headers = jsonHeaders.getTokenizedHeaders(this.state.token)
        axios
            .post('/Register/AddAccount', form, {
                headers: headers,
            })
            .then(resp => {
                if (resp && resp.data) {
                    window.localStorage.setItem(
                        'isFirstTime',
                        JSON.stringify({
                            email: this.state.email,
                        })
                    )
                    this.setState({
                        currentStep: this.state.currentStep + 1,
                    })
                    analytics.event('transaction/enroll', {
                        accountNumber: this.state.accountNumber,
                        branchId: this.state.branchId,
                        email: this.state.email,
                        lastName: this.state.lastName,
                    })
                    this.saveConsents(this.state)
                } else {
                    analytics.trace(`Add Account Response contained no data`, {
                        email: this.state.email,
                        lastName: this.state.lastName,
                        response: resp,
                    })
                    this.setState({
                        enrollingError: true,
                        currentStep: this.state.currentStep + 1,
                    })
                }
            })
            .catch(error => {
                analytics.report(error, {
                    accountNumber: this.state.accountNumber,
                    branchId: this.state.branchId,
                    email: this.state.email,
                    lastName: this.state.lastName,
                })

                this.setState({
                    enrollingError: true,
                    currentStep: this.state.currentStep + 1,
                })
            })
    }

    verifyCallback(validToken) {
        analytics.event('action/verifyCaptchaCallback', {
            token: validToken,
        })
    }

    saveConsents(customer) {
        const consumerManager = consumerConsentsService.consumerConsents();
        consumerManager.applicantData(customer);
        consumerManager.postConsentData(this.props.appConfig);
    }

    emailCheck() {
        let form = {
            email: this.state.email,
        }

        const headers = jsonHeaders.getTokenizedHeaders(this.state.token)
        axios
            .post('/Register/emailisunique', form, {
                headers: headers,
            })
            .then(resp => {
                if (resp.data) {
                    this.setState({
                        emailIsUnique: true,
                        currentStep: this.state.liveCheckCustomer
                            ? this.state.currentStep + 2
                            : this.state.currentStep + 1,
                    })

                    let form = {
                        id: this.state.id,
                        email: this.state.email,
                        firstName: this.state.firstName,
                        lastName: this.state.lastName,
                        password: this.state.password,
                        branch: this.state.branchId,
                        account: this.state.accountNumber,
                        namesId: this.state.namesId,
                    }
                    axios
                        .post(`/register/sendverificationemail`, form, {
                            headers: headers,
                        })
                        .catch(error => {
                            analytics.report(error, {
                                email: this.state.email,
                                lastName: this.state.lastName,
                            })
                        })
                } else {
                    this.setState({
                        emailIsUnique: false,
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    async handleContinue(app) {
        let currentStep = this.state.currentStep

        if (currentStep === 1) {
            let result = null
            this.setState({accountExist: false})
            try {
                result = await validateCreateAccountCheck(
                    this.state.lastName,
                    this.state.ssn,
                    this.state.dateOfBirth
                )
            } catch (err) {
                console.log(err)
            }

            if (result) {
                console.log(result)
                if (!result.verificationNeeded && result.firstName) {
                    this.setState({
                        firstName: result.firstName,
                    })
                }
                if (result.accountNumber) {
                    this.setState(
                        {
                            id: result.securityKeyId,
                            message: '',
                            currentStep: currentStep,
                            branchId: result.branchId,
                            accountNumber: result.accountNumber,
                            contractNumber: result.contractNumber,

                            lastName: result.lastName,
                            token: result.token,
                            namesId: result.namesId,
                        },
                        async () => {
                            try {
                                if (this.state.branchId) {
                                    let url = `/branch/${this.state.branchId}`
                                    const headers = jsonHeaders.getTokenizedHeaders(
                                        this.state.token
                                    )
                                    const resp = await axios.get(url, {headers: headers})

                                    this.setState({branch: resp.data})
                                }
                            } catch (err) {
                                console.log(err)
                            }
                        }
                    )
                }
            }

            if (result?.isRegistered) {
                this.setState({isRegistered: true})
                return
            } else if (!result?.verificationNeeded && result?.isCustomer) {
                this.setState({currentStep: this.state.currentStep + 2})
            } else if (result?.verificationNeeded && result?.isCustomer) {
                this.setState({currentStep: this.state.currentStep + 1})
            } else {
                this.setState({accountExist: true})
            }
        } else if (currentStep === 2) {
            let result = await validateVerification(
                this.state.firstName,
                this.state.lastName,
                this.state.suffix,
                this.state.streetAddress,
                this.state.apt,
                this.state.city,
                this.state.stateCode,
                this.state.zipCode,
                this.state.mobile,
                this.state.mobileType,
                this.state.branchId,
                this.state.accountNumber,
                this.state.token
            )
            if (result != null) {
                await result
                    .next(currentStep, this)
                    .then(() => {
                        if (result.isVerified) {
                            this.setState({liveCheckCustomer: true})
                            this.emailCheck()
                        }
                    })
                    .catch(error => {
                        console.error(error)
                    })
            }
        } else if (currentStep === 3) {
            this.emailCheck()
        } else if (currentStep === 4) {
            this.setState({currentStep: this.state.currentStep + 1})
        } else if (currentStep === 5) {
            this.setState({currentStep: this.state.currentStep + 1})
        }
    }

    handleChange(event) {
        const {name, value} = event.target
        this.setState({
            [name]: value,
        })
    }

    componentDidMount() {
        this.timer = null
    }

    render() {
        return (
            <>
                <Box minW={'25rem'}>
                    <Box>
                        <Header textStyle="b2" p="2" showLogo>
                            <Box display={{base: 'none', md: 'block'}}>
                                <Text textStyle={'b3'}>
                                    Need help? Call us at{' '}
                                    <a
                                        style={{textDecoration: 'underline', color: '#0065E0'}}
                                        href="tel:8339071737"
                                    >
                                        {' '}
                                        (833) 907-1737
                                    </a>{' '}
                                </Text>
                            </Box>
                        </Header>
                    </Box>

                    <form onSubmit={this.handleSubmit}>
                        <CreateAccount
                            appConfig={this.props.appConfig}
                            currentStep={this.state.currentStep}
                            accountExist={this.state.accountExist}
                            isRegistered={this.state.isRegistered}
                            handleChange={this.handleChange}
                            lastName={this.state.lastName}
                            ssn={this.state.ssn}
                            dateOfBirth={this.state.dateOfBirth}
                            verifyCallback={this.verifyCallback}
                            onContinue={this.handleContinue}
                        />
                        <Verification
                            currentStep={this.state.currentStep}
                            handleChange={this.handleChange}
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            mobile={this.state.mobile}
                            mobileType={this.state.mobileType}
                            failedVerification={this.state.failedVerification}
                            email={this.state.email}
                            password={this.state.password}
                            onContinue={this.handleContinue}
                            emailIsUnique={this.state.emailIsUnique}
                        />
                        <Email
                            currentStep={this.state.currentStep}
                            handleChange={this.handleChange}
                            email={this.state.email}
                            verify={this.verify}
                            emailCode={this.state.emailCode}
                            id={this.state.id}
                            token={this.state.token}
                            onContinue={this.handleContinue}
                        />
                        <Consents
                            currentStep={this.state.currentStep}
                            esignDisclosure={this.state.esignDisclosure}
                            edeliveryDisclosure={this.state.edeliveryDisclosure}
                            mobile={this.state.mobile}
                            onContinue={this.handleContinue}
                            onESignConsent={this.handleESignChange}
                            onEDeliveryConsent={this.handleEDeliveryChange}
                            onTCPAConsent={this.handleTCPAChange}
                            handleRegister={this.register}
                        />
                        <LiveCheck
                            currentStep={this.state.currentStep}
                            handleChange={this.handleChange}
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            streetAddress={this.state.streetAddress}
                            apt={this.state.apt}
                            city={this.state.city}
                            zipCode={this.state.zipCode}
                            stateCode={this.state.stateCode}
                            mobile={this.state.mobile}
                            mobileType={this.state.mobileType}
                            failedVerification={this.state.failedVerification}
                            verificationAttempts={this.state.verificationAttempts}
                            branch={this.state.branch}
                            email={this.state.email}
                            password={this.state.password}
                            onContinue={this.handleContinue}
                            emailIsUnique={this.state.emailIsUnique}
                        />
                        <Confirmation
                            currentStep={this.state.currentStep}
                            handleChange={this.handleChange}
                            onContinue={this.handleContinue}
                            enrollingError={this.state.enrollingError}
                        />
                    </form>
                    <Box bg="#EBF9FF" display={{base: 'block', md: 'none'}}>
                        <Center>
                            <Box m={8}>
                                <Text textStyle={'b3'}>
                                    Need help? Call us at{' '}
                                    <a
                                        style={{textDecoration: 'underline', color: '#0065E0'}}
                                        href="tel:8339071737"
                                    >
                                        {' '}
                                        (833) 907-1737
                                    </a>{' '}
                                </Text>
                            </Box>
                        </Center>
                    </Box>
                </Box>
                <Footer/>
            </>
        )
    }
}

export default App
